// extracted by mini-css-extract-plugin
module.exports = {"buttonOrange":"MyButton_buttonOrange__1hhhc","buttonBlue":"MyButton_buttonBlue__2d751"};